@if (!loading){

<form [formGroup]="bookingForm" class="book-session__form">
    
    <div class="row g-3 mb-4">
        <div class="col-12">
            <h1>ADD NEW BOOKING</h1>
            <h5>This booking will be assigned to you</h5>
        </div>
    </div>
    
    <div class="row g-3">


        <div class="col-12">

            <mat-form-field class="w-100" appearance="outline" hideRequiredMarker="true">
                <mat-label>Name</mat-label>
                <input type="text" matInput formControlName="name" placeholder="Eg. John Smith">
            </mat-form-field>

        </div>

        <div class="col-12">
            <mat-form-field class="w-100" appearance="outline" hideRequiredMarker="true">
                <mat-label>Location</mat-label>
                <input type="text" matInput formControlName="location" placeholder="Eg. Table 1, Seat 3">
            </mat-form-field>
        </div>
        <div class="col-12">
            <mat-form-field class="w-100" appearance="outline" hideRequiredMarker="true">
                <mat-label>Notes</mat-label>
                <input type="text" matInput formControlName="otherNotes" placeholder="Eg. Red shirt">
            </mat-form-field>
        </div>

    </div>

    <div class="row mt-3">
       
                       <div class="col-12">
                        <button [disabled]="disableForm" (click)="addBookingAndStartMassage();" class="w-100" mat-flat-button color="primary">ADD BOOKING AND ACCEPT</button>
        </div>
        <div class="col-12">
                        <button [disabled]="disableForm" (click)="addBooking();" class="w-100 mt-3" mat-button color="accent">ADD BOOKING</button>
        </div>

    </div>

</form>
}